<!-- Confirmation Modal (Figma -> Angular) -->
<div class="cancel-confirm-overlay" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
  <div class="cancel-confirm-card">
    <div class="confirm-backdrop" (click)="onCancel()"></div>
    <div class="cancel-modal">
      <!-- Icon Badge -->
      <div class="cancel-icon-ring">
        <div class="icon-ring-bg" [class.danger]="confirmColor === 'danger'"
          [class.primary]="confirmColor === 'primary'">
          <!-- Figma effect white shadow -->
          <div class="cancel-main-icon-effect"
            style="width: 75%; height: 75%; box-shadow: 4.444444179534912px 4.444444179534912px 4.444444179534912px; border-radius: 55.56px; border: 4px white solid; filter: blur(2.22px); position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
          </div>
          <img [src]="icon" alt="Icon" class="cancel-main-icon" />
        </div>
      </div>

      <!-- Content -->
      <div class="confirm-content">
        <div class="confirm-title">{{ title }}</div>
        <div class="confirm-subtext">{{ message }}</div>
      </div>

      <!-- Action Buttons -->
      <div class="confirm-actions">
        <button class="btn-base btn-close-confirm" (click)="onCancel()">
          {{ closeLabel }}
        </button>
        <button class="btn-base btn-confirm" [class.btn-danger]="confirmColor === 'danger'"
          [class.btn-primary]="confirmColor === 'primary'" (click)="onConfirm()">
          {{ confirmLabel }}
        </button>
      </div>
    </div>
  </div>
</div>